<template>
  <div>
    <div v-if="!showSuccessStep">
      <div class="ats-modal__body" v-if="currentStep === 1">
        <div class="unified-connections__select-item">
          <h3 class="unified-connections__select-label">
            {{ resource["unified.AtsTitle"] }}
          </h3>
          <multiselect
            ref="multiselect-connection"
            id="unified-connections-select"
            key="unified-connections-select"
            class="unified-connections__select"
            v-model="selectedConnectionModel"
            :placeholder="
              connectionLoading
                ? resource['placeholderLoading']
                : resource['placeholderUnifiedSelectAts']
            "
            track-by="name"
            :options="connections"
            :custom-label="customLabel"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :hide-selected="false"
            :preselect-first="true"
            :max-height="270"
            :loading="connectionLoading"
            :disabled="connectionLoading"
            @input="onInputAts(selectedConnectionModel?.type)"
          >
            <template #singleLabel="props">
              <span class="option__desc">
                <span class="option__title">
                  {{ props.option.name }}
                </span>
              </span>
            </template>
            <template #option="props">
              <div class="option__desc justify-content-between">
                <span class="option__title">{{ props.option.name }}</span>
              </div>
            </template>
            <template #noOptions>
              <span v-if="!connectionLoading">
                {{ resource["label.NoResult"] }}</span
              >
            </template>
            <template #noResult>
              <span v-if="!connectionLoading">{{
                resource["label.NoResult"]
              }}</span>
            </template>
            <template slot="afterList">
              <div class="unified-connections__select-afterlist">
                <button @click="routeIntegrationsPage()" class="add-btn">
                  <i class="icon-add"></i>
                  {{
                    resource[
                      "interviewDetail.AtsIntegrationCreateNewConnection"
                    ]
                  }}
                </button>
              </div>
            </template>
          </multiselect>
        </div>
        <div class="schedule-area" v-if="interviewType === 1">
          <div class="schedule-area__header">
            <h4>{{ resource["ScheduleAreaTitle"] }}</h4>
            <span>{{ resource["ScheduleAreaDescriptionExcel"] }}</span>
          </div>
          <div class="schedule-area__preview">
            <button
              id="schedule"
              :class="showDatePicker ? null : 'collapsed'"
              :aria-expanded="showDatePicker ? 'true' : 'false'"
              aria-controls="date-collapse"
              @click="handleDatePicker"
            >
              <div class="d-flex align-items-center justify-content-center gap-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M15.8333 3.33366H15V1.66699H13.3333V3.33366H6.66667V1.66699H5V3.33366H4.16667C3.25 3.33366 2.5 4.08366 2.5 5.00033V16.667C2.5 17.5837 3.25 18.3337 4.16667 18.3337H15.8333C16.75 18.3337 17.5 17.5837 17.5 16.667V5.00033C17.5 4.08366 16.75 3.33366 15.8333 3.33366ZM15.8333 16.667H4.16667V8.33366H15.8333V16.667ZM4.16667 6.66699V5.00033H15.8333V6.66699H4.16667ZM5.83333 10.0003H14.1667V11.667H5.83333V10.0003ZM5.83333 13.3337H11.6667V15.0003H5.83333V13.3337Z"
                    fill="#333333"
                  />
                </svg>
                {{
                  localDateRange.startDate &&
                  globalFormatTimeUserLocalWithLang(
                    localDateRange.startDate,
                    language
                  )
                }}
                -
                {{
                  localDateRange.endDate &&
                  globalFormatTimeUserLocalWithLang(localDateRange.endDate, language)
                }}
              </div>
              <span v-if="!showDatePicker">{{ resource["label.Edit"] }}</span>
              <span v-if="showDatePicker" @click="validateDateInputs">{{
                resource["label.Save"]
              }}</span>
            </button>
          </div>
          <b-collapse id="date-collapse" v-model="showDatePicker">
            <DatePicker
              ref="dateRangePicker"
              v-model="localDateRange"
              @update="handleUpdate"
              :isStartDateFixed="false"
            />
          </b-collapse>
          <b-form-checkbox
            class="checkbox-candidate d-flex align-items-center cursor-pointer"
            id="send-mail-checkbox"
            v-model="sendMail"
          >
            {{ resource["ScheduleAreaSendEmailDescription"] }}
          </b-form-checkbox>
        </div>
        <!-- <div v-if="showDatePickerError" class="error-info-area mt-3">
          <i class="icon-warning-outline"></i>
          <span>{{ resource["ScheduleAreaSelectionError"] }}</span>
          <i
            class="icon-close-rounded cursor-pointer"
            @click="showDatePickerError = false"
          ></i>
        </div>
        <div v-if="showDatePickerSaveError" class="error-info-area mt-3">
          <i class="icon-warning-outline"></i>
          <span>{{ resource["ScheduleAreaSelectionSaveError"] }}</span>
          <i
            class="icon-close-rounded cursor-pointer"
            @click="showDatePickerSaveError = false"
          ></i>
        </div>
        <div v-if="showDatePickerSuccess" class="success-info-area">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M10 1.66602C5.4 1.66602 1.66667 5.39935 1.66667 9.99935C1.66667 14.5993 5.4 18.3327 10 18.3327C14.6 18.3327 18.3333 14.5993 18.3333 9.99935C18.3333 5.39935 14.6 1.66602 10 1.66602ZM10 16.666C6.325 16.666 3.33333 13.6743 3.33333 9.99935C3.33333 6.32435 6.325 3.33268 10 3.33268C13.675 3.33268 16.6667 6.32435 16.6667 9.99935C16.6667 13.6743 13.675 16.666 10 16.666ZM13.825 6.31602L8.33333 11.8077L6.175 9.65768L5 10.8327L8.33333 14.166L15 7.49935L13.825 6.31602Z"
              fill="#19552E"
            />
          </svg>
          <span>{{ resource["ScheduleAreaSelectionSuccess"] }}</span>
        </div> -->
      </div>
      <div class="ats-modal__body" v-if="currentStep === 2">
        <div v-if="fileUploadLoading" class="loading-indicator">
          <i class="icon-spinner icon-spin"></i>
          <span>{{ resource["candidateListLoading"] }}</span>
        </div>
        <validation-observer v-slot="{ touched }" v-else>
          <div
            v-if="showCandidateListErrorMessages"
            class="error-info-area mt-3"
          >
            <i class="icon-warning-outline"></i>
            <span>{{ resource["Label.GeneralErrorText"] }}</span>
            <i
              class="icon-close-rounded cursor-pointer"
              @click="showCandidateListErrorMessages = false"
            ></i>
          </div>
          <div class="ats-modal__sticky-header">
            <div class="search-container">
              <div class="search-info">
                <span>{{ resource["addCandidateModalListInfo"] }}</span>
              </div>
              <div class="search-input-wrapper">
                <input
                  type="text"
                  v-model="searchTerm"
                  :placeholder="resource['addCandidateModalSearchPlaceholder']"
                  class="search-input"
                />
                <div class="search-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z"
                      stroke="#878787"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="interview-input-header">
              <div class="checkbox-column">
                <div class="select-all-checkbox">
                  <b-form-checkbox
                    id="selectAll"
                    class="checkbox-candidate"
                    :checked="isAllSelected"
                    @change="toggleSelectAll"
                  />
                </div>
              </div>
              <div class="input-columns">
                <span>{{ resource["hrvenue.createCandidate.Name"] }}</span>
                <span>{{ resource["hrvenue.createCandidate.Surname"] }}</span>
                <span>{{ resource["hrvenue.createCandidate.Email"] }}</span>
              </div>
            </div>
          </div>
          <div class="candidates-list">
            <div
              :class="['interview-input-group', touched ? 'touched' : '']"
              v-for="(candidate, indexAt) in visibleCandidates"
              :key="indexAt"
            >
              <div class="candidate-checkbox">
                <b-form-checkbox
                  class="checkbox-candidate"
                  :id="`candidate-${indexAt}`"
                  :checked="isSelected(candidate)"
                  @change="toggleSelection(candidate)"
                />
              </div>

              <validation-observer v-slot="{ }">
                <validate-form
                  :id="`name`"
                  type="text"
                  v-model="candidate.name"
                  :name="resource['hrvenue.createCandidate.Name']"
                  rules="required|min:2|validChar"
                  :placeholder="resource['hrvenue.candidateNamePlaceholder']"
                  @keypress="maxLengthCheck($event, 75, 'name', indexAt)"
                  @keyup="maxLengthCheck($event, 75, 'name', indexAt)"
                  @input="updateSelectedCandidate(candidate, indexAt)"
                  :classGroup="'touched'"
                >
                </validate-form>
              </validation-observer>

              <validation-observer v-slot="{ }">
                <validate-form
                  :id="`surname`"
                  :name="resource['hrvenue.createCandidate.Surname']"
                  v-model="candidate.surname"
                  type="text"
                  rules="validChar"
                  :placeholder="resource['hrvenue.candidateSurNamePlaceholder']"
                  @keypress="maxLengthCheck($event, 75, 'surname', indexAt)"
                  @keyup="maxLengthCheck($event, 75, 'surname', indexAt)"
                  @input="updateSelectedCandidate(candidate, indexAt)"
                  :classGroup="'touched'"
                >
                </validate-form>
              </validation-observer>

              <validation-observer v-slot="{ }">
                <validate-form
                  :id="`email`"
                  :name="resource['hrvenue.createCandidate.Email']"
                  v-model="candidate.email"
                  type="text"
                  rules="onlyEnglishLetters|required|min:10|max:300|emailRegex"
                  :placeholder="resource['hrvenue.candidateEmailPlaceholder']"
                  @keypress="maxLengthCheck($event, 300, 'email', indexAt)"
                  @keyup="maxLengthCheck($event, 300, 'email', indexAt)"
                  @input="updateSelectedCandidate(candidate, indexAt)"
                  :classGroup="'touched'"
                >
                </validate-form>
              </validation-observer>
              <div
                v-if="visibleCandidates.length > 1"
                @click="clickDelete(indexAt)"
                :id="`delete${indexAt}FormInput`"
                :name="`delete${indexAt}`"
                class="cursor-pointer delete-icon"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M12.2 3.80714C11.94 3.54714 11.52 3.54714 11.26 3.80714L7.99998 7.06047L4.73998 3.80047C4.47998 3.54047 4.05998 3.54047 3.79998 3.80047C3.53998 4.06047 3.53998 4.48047 3.79998 4.74047L7.05998 8.00047L3.79998 11.2605C3.53998 11.5205 3.53998 11.9405 3.79998 12.2005C4.05998 12.4605 4.47998 12.4605 4.73998 12.2005L7.99998 8.94047L11.26 12.2005C11.52 12.4605 11.94 12.4605 12.2 12.2005C12.46 11.9405 12.46 11.5205 12.2 11.2605L8.93998 8.00047L12.2 4.74047C12.4533 4.48714 12.4533 4.06047 12.2 3.80714Z"
                    fill="#333333"
                  />
                </svg>
              </div>
              <div v-else class="delete-icon-empty">&nbsp;</div>
            </div>
          </div>
        </validation-observer>
        <div v-if="isLoadingMore" class="loading-indicator">
          <i class="icon-spinner icon-spin"></i>
          <span>{{ resource["candidateListScrollingLoading"] }}</span>
        </div>
        <div
          v-if="!isLoadingMore && visibleCandidates.length === 0"
          class="no-results-message"
        >
          <span>{{ resource["addCandidateModalSearchNoResults"] }}</span>
        </div>

        <!-- End of list indicator -->
        <div
          v-if="
            allCandidatesLoaded &&
            visibleCandidates.length > 0 &&
            visibleCandidates.length > paginationConfig.pageSize
          "
          class="end-list-indicator"
        >
          <span>{{ resource["candidateListScrollingEnd"] }}</span>
        </div>

        <!-- Selected candidates summary -->
      </div>
      <div class="ats-modal__footer">
        <div class="selected-summary">
          <span v-if="selectedCandidates.length > 0 && currentStep === 2"
            ><i class="icon-info"></i
            >{{
              `${selectedCandidates.length}/${candidate.candidates.length} ${resource["candidateListSelected"]}`
            }}</span
          >
        </div>
        <div class="button-group">
          <b-button
            v-if="currentStep > 1 && totalSteps > 1"
            name="back"
            class="border-button-create"
            @click="backHandler"
          >
            <span>{{ resource["addCandidateModalBackBtn"] }}</span>
          </b-button>
          <b-button
            v-else
            name="cancel"
            class="border-button-create"
            @click="hiddenModal"
          >
            <span>{{ resource["addCandidateModalCancelBtn"] }}</span>
          </b-button>
          <b-button
            v-if="currentStep < totalSteps && totalSteps > 1"
            name="next"
            class="bg-button gap-2 d-flex align-items-center"
            :disabled="!selectedConnectionModel || noCandidatesFound"
            @click="nextHandler"
          >
            <span>{{ resource["addCandidateModalNextBtn"] }}</span>
          </b-button>
          <b-button
            v-else
            name="add"
            class="bg-button gap-2 d-flex align-items-center"
            :disabled="buttonLoading"
            @click="submitHandler()"
          >
            <i
              v-if="buttonLoading"
              class="icon-spinner icon-spin"
              width="20"
              height="20"
            />
            <span>{{ resource["addCandidateSModalSubmitBtn"] }}</span>
          </b-button>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="ats-modal__body">
        <div class="ats-modal__success">
          <img
            class="sended-mail-icon"
            :src="require('@/assets/hrVenue/add-candidate-succes.svg')"
          />
          <h3>
            {{ sendedCandidates.length }}
            {{ resource["addCandidateModalSuccessTitle"] }}
          </h3>
          <div v-if="interviewType === 1">
            <span v-if="sendMail">{{resource["addCandidateModalExcelSuccessSendMailDescription"]}}</span>
            <span v-else>{{resource["addCandidateModalExcelSuccessNotSendMailDescription"]}}</span>
          </div>
        </div>
      </div>
      <div class="ats-modal__footer">
        <b-button
          name="add"
          class="bg-button d-flex align-items-center download-btn"
          @click="successPageHandler"
        >
          <span>
            {{ resource["addCandidateModalDownloadExcelBtn"] }}
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M11.9998 9.99935V11.9993H3.99984V9.99935H2.6665V11.9993C2.6665 12.7327 3.2665 13.3327 3.99984 13.3327H11.9998C12.7332 13.3327 13.3332 12.7327 13.3332 11.9993V9.99935H11.9998ZM11.3332 7.33268L10.3932 6.39268L8.6665 8.11268V2.66602H7.33317V8.11268L5.6065 6.39268L4.6665 7.33268L7.99984 10.666L11.3332 7.33268Z"
              fill="white"
            />
          </svg>
          <!-- <span v-if="sendMail">{{
            resource["addCandidateModalBackListBtn"]
          }}</span> -->
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ResourceManager from '@/services/resource.service';
import { showNotification } from '../../../static/helpers';
import DatePicker from '../../common/DatePicker.vue';
import hrvenueService from '../../../services/hrvenue.service';

export default {
  name: 'atsModal',
  components: {
    DatePicker,
  },
  props: {
    candidate: { type: Object, required: true },
    dateRange: { type: Object, required: true },
    invalid: { type: Boolean, default: true },
    buttonLoading: { type: Boolean, default: false },
    currentStep: { type: Number, default: 0 },
    totalSteps: { type: Number, default: 0 },
    showSuccessStep: { type: Boolean, default: false },
    sendableCount: { type: Number, default: 0 },
    sendedCandidates: { type: Array, default: () => [] },
    unSendedCandidates: { type: Array, default: () => [] },
    totalSendedCount: { type: Number, default: 0 },
    interviewType: { type: Number, default: 1 },
  },
  data() {
    return {
      localDateRange: { ...this.dateRange },
      showDateModalError: false,
      showDatePicker: false,
      sendMail: true,
      datePickerValid: true,

      notificationShowed: false,
      displayedCandidates: [],
      isLoadingMore: false,
      allCandidatesLoaded: false,
      fileUploadLoading: true,
      searchTerm: '',
      selectedCandidates: [],
      showCandidateListErrorMessages: false,
      showDatePickerError: false,
      showDatePickerSaveError: false,
      showDatePickerSuccess: false,
      language: 'en-US',

      paginationConfig: {
        pageSize: 20,
        currentPage: 0,
        totalItems: 0,
      },
      selectedConnectionModel: null,
      connectionLoading: false,
      connections: [],
      currentConnectionType: null,
      atsData: {
        candidates: [],
      },
      hasNextPageCandidates: true,
      currentOffsetCandidate: 0,
      searchTimeout: null, // For debouncing search
      noCandidatesFound: false,
      preSearchHasNextPageCandidates: true,
      preSearchDisplayedCandidates: [], // Store displayed candidates before search
      preSearchCurrentPage: 1, // Store current page before search
      preSearchAllCandidatesLoaded: false,
      isSearchActive: false, // Track if we're in search mode
      deleteOperation: false,
    };
  },
  created() {
    this.language = typeof ResourceManager.CurrentLang !== 'string'
      ? ResourceManager.CurrentLang.key
      : ResourceManager.CurrentLang;
    this.getUnifiedAts();
  },
  mounted() {
    // Add scroll event listener to modal body
    this.$nextTick(() => {
      const modalBody = document.querySelector('.ats-modal__body');
      if (modalBody) {
        modalBody.addEventListener('scroll', this.handleScroll);
      }
    });
  },
  beforeDestroy() {
    // Remove event listener
    const modalBody = document.querySelector('.ats-modal__body');
    if (modalBody) {
      modalBody.removeEventListener('scroll', this.handleScroll);
    }
  },
  computed: {
    filteredCandidates() {
      if (!this.searchTerm) {
        return this.candidate.candidates;
      }

      const searchLower = this.searchTerm.toLowerCase();
      return this.candidate.candidates.filter(
        (candidate) => (candidate.name
            && candidate.name.toLowerCase().includes(searchLower))
          || (candidate.surname
            && candidate.surname.toLowerCase().includes(searchLower))
          || (candidate.email
            && candidate.email.toLowerCase().includes(searchLower)),
      );
    },
    visibleCandidates() {
      if (!this.searchTerm) {
        return this.displayedCandidates;
      }

      // When searching, show all matching candidates from the filtered set
      const pageSize = this.paginationConfig.pageSize;
      const currentPage = this.paginationConfig.currentPage;
      const startIndex = (currentPage - 1) * pageSize;
      return this.filteredCandidates.slice(startIndex, startIndex + pageSize);
    },
    isAllSelected() {
      if (this.visibleCandidates.length === 0) return false;
      return this.visibleCandidates.every((candidate) => this.isSelected(candidate));
    },
  },
  methods: {
    customLabel({ name }) {
      // eslint-disable-next-line camelcase
      return `${name}`;
    },

    async getUnifiedAts() {
      try {
        this.connectionLoading = true;
        const response = await hrvenueService.getUnifiedIntegrations();
        // this.connections = response.map((item) => (item.connected ? item : { ...item, $isDisabled: true })).sort((a, b) => b.connected - a.connected);
        this.connections = response?.filter((item) => item.connected);
        if (this.connections.length > 0 && !this.selectedConnectionModel) {
          this.selectedConnectionModel = this.connections[0];
          this.onInputAts(this.connections[0].type);
        }
      } catch (error) {
        showNotification(this.resource['label.error'], error.message, 'error');
      } finally {
        this.connectionLoading = false;
      }
    },

    onInputAts(type) {
      if (!type) {
        return;
      }
      this.fetchAtsCandidate(type);
    },

    async fetchAtsCandidate(connectionType) {
      try {
        this.noCandidatesFound = false;
        this.showCandidateListErrorMessages = false;
        this.fileUploadLoading = true;
        this.$emit('updateCandidate', {
          candidates: [
            {
              name: '',
              surname: '',
              email: '',
            },
          ],
        });

        this.currentConnectionType = connectionType;
        this.currentOffsetCandidate = 0;
        this.hasNextPageCandidates = true;
        this.atsData = { candidates: [] };

        // Clear any previous candidate data
        this.selectedCandidates = [];
        this.displayedCandidates = [];
        this.preSearchDisplayedCandidates = []; // Reset pre-search state
        this.isSearchActive = false; // Reset search active state

        // Reset pagination
        this.paginationConfig.currentPage = 1;
        this.preSearchCurrentPage = 1;
        this.paginationConfig.totalItems = 0;
        this.preSearchAllCandidatesLoaded = false;
        this.allCandidatesLoaded = false;
        this.preSearchHasNextPageCandidates = true;

        const candidates = await hrvenueService.getUnifiedData(
          'ats',
          connectionType,
          'candidate',
          `offset=${this.currentOffsetCandidate}&limit=${this.paginationConfig.pageSize}&fields=id,name,emails`,
        );

        if (!candidates?.length) {
          this.hasNextPageCandidates = false;
          this.atsData.candidates = [];
          showNotification(
            this.resource['label.error'],
            'No candidates found',
            'error',
          );
          this.noCandidatesFound = true;
        } else {
          if (candidates.length < this.paginationConfig.pageSize) {
            this.hasNextPageCandidates = false;
          }

          this.processReceivedCandidates(candidates);
        }

        this.initPagination();

        // Select all after candidates are loaded and displayed
        this.$nextTick(() => {
          this.selectAllCandidates();
        });
      } catch (error) {
        showNotification(this.resource['label.error'], error.message, 'error');
      } finally {
        this.fileUploadLoading = false;
      }
    },

    processReceivedCandidates(candidates) {
      if (!candidates || candidates.length === 0) return;

      candidates.forEach((row) => {
        const [firstName, ...lastNameParts] = row.name?.split(' ') || ['', ''];
        const newRow = {
          name: firstName || '',
          surname: lastNameParts?.join(' ') || '',
          email: row.emails?.[0]?.email || '',
          key: 'ats',
          _tempId: `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        };

        const isValid = this.validateFields(newRow);
        if (newRow.name || newRow.surname || newRow.email) {
          this.createNewInterViewer({ ...newRow, isValid });
        }
      });

      setTimeout(() => {
        this.restoreValidationStates();
      }, 100);

      const groupedData = this.groupBy();
      let hasErrorItems = [];
      if (groupedData.false) {
        this.showCandidateListErrorMessages = true;
        hasErrorItems = [...groupedData.false];
      }
      const hasSuccessItems = groupedData.true ? [...groupedData.true] : [];

      if (hasErrorItems.length > 0 || hasSuccessItems.length > 0) {
        this.candidate.candidates = [
          ...this.candidate.candidates.filter(
            (candidate) => !candidate.key
              && (candidate.name || candidate.surname || candidate.email),
          ),
          ...hasErrorItems,
          ...hasSuccessItems,
        ];
      }
    },

    handleDatePicker() {
      this.showDatePicker = !this.showDatePicker;
      if (this.showDatePicker) {
        this.showDatePickerError = false;
        this.showDatePickerSaveError = false;
        this.showDatePickerSuccess = false;
      }
    },
    backHandler() {
      this.$emit('prev');

      setTimeout(() => {
        this.currentOffsetCandidate = 0;
        this.hasNextPageCandidates = true;
        this.allCandidatesLoaded = false;
        this.selectedConnectionModel = null;
        this.currentConnectionType = null;
        this.atsData = { candidates: [] };
        this.selectedCandidates = [];
        this.displayedCandidates = [];
        this.paginationConfig.currentPage = 1;
        this.paginationConfig.totalItems = 0;
        this.noCandidatesFound = false;
        this.showCandidateListErrorMessages = false;
        this.fileUploadLoading = true;

        this.$emit('updateCandidate', {
          candidates: [{
            name: '',
            surname: '',
            email: '',
          }],
        });
        setTimeout(() => {
          this.getUnifiedAts();
        }, 50);
      }, 50);
    },
    nextHandler() {
      if (this.showDatePicker) {
        this.showDatePickerSaveError = true;
        this.showDatePickerSuccess = false;
        this.showDatePickerError = false;
        showNotification(
          this.resource['Label.Error'],
          this.resource.ScheduleAreaSelectionSaveError,
          'error',
        );
        this.scrollToBottom();
        return;
      }
      if (!this.datePickerValid) {
        this.showDatePickerSaveError = false;
        this.showDatePickerSuccess = false;
        this.showDatePickerError = true;
        showNotification(
          this.resource['Label.Error'],
          this.resource.ScheduleAreaSelectionError,
          'error',
        );
        this.scrollToBottom();
        return;
      }
      if (this.noCandidatesFound) {
        return;
      }
      if (this.selectedConnectionModel && this.datePickerValid) {
        // Set loading state before transition
        this.fileUploadLoading = true;

        // Move to the next step immediately
        this.$emit('next');
        this.showDatePickerError = false;
        this.showDatePickerSaveError = false;
        this.showDatePickerSuccess = false;
      }
    },
    submitHandler() {
      const hasInvalidSelectedCandidate = this.selectedCandidates.some(
        (selectedCandidate) => !selectedCandidate.isValid,
      );

      if (hasInvalidSelectedCandidate || this.selectedCandidates.length === 0) {
        this.scrollToTop();
        this.showCandidateListErrorMessages = true;
        return;
      }

      if (!this.buttonLoading || this.datePickerValid) {
        const values = {
          dateRange: this.localDateRange,
          sendMail: this.sendMail,
          selectedCandidates: this.selectedCandidates,
        };
        this.$emit('submit', values);
      }
    },
    handleUpdate(value) {
      this.localDateRange = { ...value };
      this.$emit('update:dateRange', this.localDateRange);
    },
    hiddenModal() {
      this.$emit('onHide');
      this.localDateRange = {
        startDate: new Date(),
        endDate: new Date(new Date().setDate(new Date().getDate() + 7)),
        startTime: null,
        endTime: null,
        selectedDuration: '7',
      };
      this.showDateModalError = false;
      this.showDatePicker = false;
      this.sendMail = true;
      this.datePickerValid = true;
      this.selectedCandidates = [];
    },
    validateDateInputs() {
      const {
        startDate, endDate, startTime, endTime, selectedDuration,
      } = this.localDateRange;
      const isValid = [
        startDate,
        endDate,
        startTime,
        endTime,
        selectedDuration,
      ].every(Boolean);

      this.showDateModalError = !isValid;
      this.datePickerValid = isValid;
      this.showDatePickerSuccess = isValid;
      this.showDatePickerError = !isValid;
      this.showDatePickerSaveError = false;
      if (isValid) {
        showNotification(
          this.resource['Label.Success'],
          this.resource.ScheduleAreaSelectionSuccess,
          'success',
        );
      } else {
        showNotification(
          this.resource['Label.Error'],
          this.resource.ScheduleAreaSelectionError,
          'error',
        );
      }
      this.scrollToBottom();

      return isValid;
    },
    checkValidateRule(candidate) {
      this.$emit('onValidateField', candidate);
    },
    setWhichInput(InpEl, value, indexAt) {
      if (InpEl === 'name') {
        this.candidate.candidates[indexAt].name = value;
      } else if (InpEl === 'surname') {
        this.candidate.candidates[indexAt].surname = value;
      } else {
        this.candidate.candidates[indexAt].email = value;
      }
    },
    maxLengthCheck(event, maxLength, inp, indexAt) {
      const value = event.target.value;
      if (!maxLength || String(value).length <= maxLength) {
        this.setWhichInput(inp, value, indexAt);
      } else {
        this.setWhichInput(inp, value.substring(0, maxLength), indexAt);
        event.stopPropagation();
      }

      const candidate = this.candidate.candidates[indexAt];
      if (candidate && candidate._tempId) {
        this.updateSelectedCandidate(candidate, indexAt);
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const modalBody = document.querySelector('.ats-modal__body');
        if (modalBody) {
          modalBody.scrollTo({
            top: modalBody.scrollHeight,
            behavior: 'smooth',
          });
        }
      });
    },
    scrollToTop() {
      this.$nextTick(() => {
        const modalBody = document.querySelector('.ats-modal__body');
        if (modalBody) {
          modalBody.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }
      });
    },
    validateFields(obj) {
      if (obj.name === undefined || obj.email === undefined) {
        obj.name = obj.name !== undefined ? obj.name.slice(0, 75) : obj.name;
        // obj.surname = obj.surname !== undefined ? obj.surname.slice(0, 75) : obj.surname;
        return false;
      }
      const nameMatch = obj.name?.match(/[a-zA-ZğüşöçıİĞÜŞÖÇ\s]/g);
      // const surnameMatch = obj.surname?.match(/[a-zA-ZğüşöçıİĞÜŞÖÇ\s]/g);

      obj.name = nameMatch ? nameMatch.join('').slice(0, 75) : '';
      // obj.surname = surnameMatch ? surnameMatch.join('').slice(0, 75) : '';
      // eslint-disable-next-line no-useless-escape
      const validEmail = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$/.test(obj.email);
      const validLength = (obj.name?.length >= 2 && obj.email?.length >= 10 && obj.email?.length <= 300);
      const validName = /^[a-zA-ZğüşöçıİĞÜŞÖÇ\s]*$/.test(obj.name);
      // const validSurname = /^[a-zA-ZğüşöçıİĞÜŞÖÇ\s]*$/.test(obj.surname);
      if (validEmail && validLength && validName) {
        return true;
      }
      return false;
    },
    createNewInterViewer(candidateObj) {
      if (this.candidate.candidates.length < this.sendableCount) {
        if (candidateObj) {
          if (
            !candidateObj.name
            && !candidateObj.surname
            && !candidateObj.email
          ) {
            return;
          }
          const isValid = this.validateFields(candidateObj);
          const _tempId = `${Date.now()}_${Math.random()
            .toString(36)
            .substr(2, 9)}`;
          const newCandidate = { ...candidateObj, isValid, _tempId };
          const lastChildCandidate = this.candidate.candidates.length - 1;
          const lastChildCandidateName = this.candidate.candidates[lastChildCandidate].name;
          const lastChildCandidateSurname = this.candidate.candidates[lastChildCandidate].surname;
          const lastChildCandidateEmail = this.candidate.candidates[lastChildCandidate].email;
          if (
            lastChildCandidateName === undefined
            && lastChildCandidateSurname === undefined
            && lastChildCandidateEmail === undefined
          ) {
            this.candidate.candidates.pop();
            this.candidate.candidates.push(newCandidate);
          } else {
            this.candidate.candidates.push(newCandidate);
          }
        } else {
          this.candidate.candidates.push({});
        }
        setTimeout(() => {
          this.restoreValidationStates();
        }, 100);
      } else if (!this.notificationShowed) {
        this.notificationShowed = true;
        return showNotification(
          this.resource['Label.Error'],
          this.resource['candidateDetail.candidateNumberExceedError'],
          'error',
        );
      }
    },
    groupBy() {
      return this.candidate.candidates.reduce((r, a) => {
        r[a.isValid] = r[a.isValid] || [];
        r[a.isValid].push(a);
        return r;
      }, Object.create(null));
    },
    initPagination() {
      // Delay this process to prevent UI freeze
      setTimeout(() => {
        const candidates = this.searchTerm
          ? this.filteredCandidates
          : this.candidate.candidates;
        this.paginationConfig.totalItems = candidates.length;
        this.paginationConfig.currentPage = 1;
        this.displayedCandidates = candidates.slice(
          0,
          this.paginationConfig.pageSize,
        );

        // Initialize pre-search state
        if (!this.isSearchActive) {
          this.preSearchDisplayedCandidates = [...this.displayedCandidates];

          this.preSearchCurrentPage = this.paginationConfig.currentPage;
          this.preSearchAllCandidatesLoaded = this.allCandidatesLoaded;
          this.preSearchHasNextPageCandidates = this.hasNextPageCandidates;
        }

        this.allCandidatesLoaded = this.displayedCandidates.length >= candidates.length
          && !this.hasNextPageCandidates;

        // Update selected candidates when initialized
        this.updateSelectedCandidatesAfterChange();

        // Further delay the validation to ensure smooth UI
        setTimeout(() => {
          this.restoreValidationStates();
          this.fileUploadLoading = false;
        }, 150);
      }, 100);
    },

    handleScroll(event) {
      if (this.currentStep !== 2) return;

      const container = event.target;
      const scrollPosition = container.scrollTop + container.clientHeight;
      const scrollHeight = container.scrollHeight;

      // Load more when user scrolls to bottom
      if (
        scrollHeight - scrollPosition < 100
        && !this.isLoadingMore
        && !this.allCandidatesLoaded
      ) {
        if (this.searchTerm) {
          // When searching, just load more from the filtered results
          this.loadMoreCandidates();
        } else {
          // When not searching, fetch more from API
          this.loadMoreFromApi();
        }
      }
    },

    async loadMoreFromApi() {
      if (
        !this.currentConnectionType
        || !this.hasNextPageCandidates
        || this.isLoadingMore
      ) return;

      try {
        this.isLoadingMore = true;
        this.currentOffsetCandidate += this.paginationConfig.pageSize;

        const candidates = await hrvenueService.getUnifiedData(
          'ats',
          this.currentConnectionType,
          'candidate',
          `offset=${this.currentOffsetCandidate}&limit=${this.paginationConfig.pageSize}&fields=id,name,emails`,
        );

        if (candidates?.length) {
          // Process and add the new candidates
          this.processReceivedCandidates(candidates);

          // Update pagination
          this.paginationConfig.currentPage += 1;

          // Add new candidates to displayed list
          this.displayedCandidates = [
            ...this.candidate.candidates,
          ];

          // Update preSearch state if not in search mode
          if (!this.isSearchActive) {
            this.preSearchDisplayedCandidates = [...this.displayedCandidates];
            this.preSearchCurrentPage = this.paginationConfig.currentPage;
            this.preSearchAllCandidatesLoaded = this.allCandidatesLoaded;
            this.preSearchHasNextPageCandidates = this.hasNextPageCandidates;
          }

          // Update total count
          this.paginationConfig.totalItems = this.candidate.candidates.length;

          // Check if we've reached the end
          if (candidates.length < this.paginationConfig.pageSize) {
            this.hasNextPageCandidates = false;
            this.allCandidatesLoaded = true;
          }

          this.$nextTick(() => {
            this.selectAllCandidates();
          });
        } else {
          this.hasNextPageCandidates = false;
          this.allCandidatesLoaded = true;
        }
      } catch (error) {
        showNotification(this.resource['label.error'], error.message, 'error');
      } finally {
        this.isLoadingMore = false;
      }
    },

    loadMoreCandidates() {
      if (this.isLoadingMore || this.allCandidatesLoaded) return;

      this.isLoadingMore = true;

      setTimeout(() => {
        const candidates = this.searchTerm
          ? this.filteredCandidates
          : this.candidate.candidates;
        const nextPage = this.paginationConfig.currentPage + 1;
        const startIndex = this.paginationConfig.pageSize * (nextPage - 1);
        const endIndex = startIndex + this.paginationConfig.pageSize;

        const newItems = candidates.slice(startIndex, endIndex);

        if (newItems.length > 0) {
          this.displayedCandidates = [...this.displayedCandidates, ...newItems];
          this.paginationConfig.currentPage = nextPage;
          this.allCandidatesLoaded = endIndex >= candidates.length;

          // If we're not in search mode, update the preSearchDisplayedCandidates too
          if (!this.isSearchActive) {
            this.preSearchDisplayedCandidates = [...this.displayedCandidates];
            this.preSearchCurrentPage = this.paginationConfig.currentPage;
            this.preSearchAllCandidatesLoaded = this.allCandidatesLoaded;
            this.preSearchHasNextPageCandidates = this.hasNextPageCandidates;
          }
        } else {
          this.allCandidatesLoaded = true;
        }

        this.isLoadingMore = false;
      }, 50);
    },

    searchCandidates() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      const isSearchCleared = this.isSearchActive && !this.searchTerm;

      // Save current state before starting a new search
      if (!this.isSearchActive && this.searchTerm) {
        this.isSearchActive = true;
        this.preSearchDisplayedCandidates = [...this.displayedCandidates];
        this.preSearchCurrentPage = this.paginationConfig.currentPage;
        this.preSearchAllCandidatesLoaded = this.allCandidatesLoaded;
        this.preSearchHasNextPageCandidates = this.hasNextPageCandidates;
      }

      // If search is being cleared, restore previous state
      if (isSearchCleared) {
        this.isSearchActive = false;
        this.displayedCandidates = [...this.preSearchDisplayedCandidates];
        this.paginationConfig.currentPage = this.preSearchCurrentPage;
        this.allCandidatesLoaded = this.preSearchAllCandidatesLoaded;
        this.hasNextPageCandidates = this.preSearchHasNextPageCandidates;

        // Update loaded state
        this.allCandidatesLoaded = this.displayedCandidates.length >= this.candidate.candidates.length
          && !this.hasNextPageCandidates;

        return;
      }

      // Reset pagination for new search
      if (this.searchTerm) {
        this.paginationConfig.currentPage = 1;

        // Reset offset when search is changed
        this.currentOffsetCandidate = 0;
        this.hasNextPageCandidates = true;
        this.allCandidatesLoaded = false;

        // Use local search if we have already loaded candidates
        if (this.candidate.candidates.length > 0) {
          const candidates = this.filteredCandidates;
          this.displayedCandidates = candidates.slice(
            0,
            this.paginationConfig.pageSize,
          );
          this.allCandidatesLoaded = this.displayedCandidates.length >= candidates.length
            && !this.hasNextPageCandidates;

          this.$nextTick(() => {
            this.restoreValidationStates();
          });
        } else {
          // If we don't have candidates yet, fetch from API
          this.searchTimeout = setTimeout(() => {
            this.fetchAtsCandidate(this.currentConnectionType);
          }, 300);
        }
      }
    },

    clickDelete(indexAt) {
      if (this.deleteOperation) {
        return;
      }
      this.deleteOperation = true;
      const candidateToDelete = this.visibleCandidates[indexAt];
      // Find its index in the original full list
      const actualIndex = this.candidate.candidates.findIndex((c) => c._tempId === candidateToDelete._tempId
        || (c.email === candidateToDelete.email
        && c.name === candidateToDelete.name
        && c.surname === candidateToDelete.surname));

      // Remove from selected candidates if it was selected
      if (this.isSelected(candidateToDelete)) {
        if (candidateToDelete._tempId) {
          this.selectedCandidates = this.selectedCandidates.filter(
            (sc) => sc._tempId !== candidateToDelete._tempId,
          );
        }
      }

      // Create updated candidates list
      const updatedCandidates = [
        ...this.candidate.candidates.slice(0, actualIndex),
        ...this.candidate.candidates.slice(actualIndex + 1),
      ];

      // Emit the update with a copy to prevent reference issues
      this.$emit('updateCandidate', {
        candidates: JSON.parse(JSON.stringify(updatedCandidates)),
      });

      // Handle pagination and display updates
      if (this.searchTerm) {
        // When searching, just refresh the filtered list
        this.paginationConfig.totalItems = this.filteredCandidates.length - 1;
        const startIndex = (this.paginationConfig.currentPage - 1)
          * this.paginationConfig.pageSize;
        const endIndex = startIndex + this.paginationConfig.pageSize;
        this.displayedCandidates = this.filteredCandidates.slice(
          startIndex,
          endIndex,
        );
      } else {
        // eslint-disable-next-line no-lonely-if
        if (
          this.displayedCandidates.length === 1
          && this.paginationConfig.currentPage > 1
        ) {
          this.paginationConfig.currentPage -= 1;

          const startIndex = this.paginationConfig.pageSize
            * (this.paginationConfig.currentPage - 1);
          const endIndex = startIndex + this.paginationConfig.pageSize;
          this.displayedCandidates = this.candidate.candidates.slice(
            startIndex,
            endIndex,
          );
        } else {
          this.displayedCandidates.splice(indexAt, 1);

          if (
            this.displayedCandidates.length < this.paginationConfig.pageSize
            && this.candidate.candidates.length
              > this.paginationConfig.pageSize * this.paginationConfig.currentPage
          ) {
            const nextItemIndex = this.paginationConfig.pageSize
              * this.paginationConfig.currentPage;
            if (this.candidate.candidates[nextItemIndex]) {
              this.displayedCandidates.push(this.candidate.candidates[nextItemIndex]);
            }
          }
        }
      }

      // Preserve validation states after deletion
      this.$nextTick(() => {
        this.updateSelectedCandidatesAfterChange();
        this.restoreValidationStates();
      });
      setTimeout(() => {
        this.deleteOperation = false;
      }, 150);
    },

    // Selection methods
    isSelected(candidate) {
      if (!candidate) return false;

      return this.selectedCandidates.some(
        (sc) => sc._tempId === candidate._tempId,
      );
    },

    toggleSelection(candidate) {
      if (!candidate) return;

      if (this.isSelected(candidate)) {
        if (candidate._tempId) {
          this.selectedCandidates = this.selectedCandidates.filter(
            (sc) => sc._tempId !== candidate._tempId,
          );
        }
      } else {
        // Add a deep clone of the candidate to the selection
        const candidateToAdd = JSON.parse(JSON.stringify(candidate));
        candidateToAdd.isValid = this.validateFields({
          name: candidateToAdd.name,
          surname: candidateToAdd.surname,
          email: candidateToAdd.email,
        });
        this.selectedCandidates.push(candidateToAdd);
      }
    },

    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedCandidates = [];
      } else {
        this.selectAllCandidates();
      }
    },

    selectAllCandidates() {
      if (this.candidate.candidates && this.candidate.candidates.length > 0) {
        this.selectedCandidates = [];

        this.candidate.candidates.forEach((candidate) => {
          const candidateToAdd = JSON.parse(JSON.stringify(candidate));

          candidateToAdd.isValid = this.validateFields({
            name: candidateToAdd.name,
            surname: candidateToAdd.surname,
            email: candidateToAdd.email,
          });

          this.selectedCandidates.push(candidateToAdd);
        });
      }
    },

    updateSelectedCandidatesAfterChange() {
      const validSelectedCandidates = [];

      this.selectedCandidates.forEach((selected) => {
        const stillExists = this.candidate.candidates.some(
          (candidate) => selected._tempId === candidate._tempId,
        );

        if (stillExists) {
          validSelectedCandidates.push(selected);
        }
      });

      this.selectedCandidates = validSelectedCandidates;
    },
    restoreValidationStates() {
      setTimeout(() => {
        document.querySelectorAll('.interview-input-group').forEach((el) => {
          const formGroups = el.querySelectorAll('.form-group');
          formGroups.forEach((inp) => {
            inp.classList.remove('untouched');
            inp.classList.add('touched');
          });
        });
      }, 50);
    },
    successPageHandler() {
      this.$emit('downloadExcel');
    },
    updateSelectedCandidate(candidate) {
      this.checkValidateRule(candidate);

      // Find the candidate in the selectedCandidates array by _tempId
      if (candidate._tempId) {
        const selectedIndex = this.selectedCandidates.findIndex(
          (sc) => sc._tempId === candidate._tempId,
        );

        if (selectedIndex !== -1) {
          // Update the selected candidate with the new values
          this.selectedCandidates[selectedIndex] = {
            ...this.selectedCandidates[selectedIndex],
            name: candidate.name,
            surname: candidate.surname,
            email: candidate.email,
            isValid: this.validateFields({
              name: candidate.name,
              surname: candidate.surname,
              email: candidate.email,
            }),
          };
        }
      }
    },
    routeIntegrationsPage() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({ name: 'IntegrationsView', params: { lang } });
    },
  },
  watch: {
    showDatePicker(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.scrollToBottom();
        }, 250);
      }
    },
    dateRange: {
      handler(newVal) {
        this.localDateRange = { ...newVal };
      },
      deep: true,
    },
    currentStep(newVal) {
      if (newVal === 2 && this.candidate.candidates.length > 0) {
        // Keep loading state active
        this.fileUploadLoading = true;

        // Delay initialization to let the UI transition complete
        setTimeout(() => {
          this.initPagination();
          this.restoreValidationStates();

          // Select all candidates after a delay
          setTimeout(() => {
            this.selectAllCandidates();
          }, 150);
        }, 150);
      }
    },
    searchTerm() {
      this.searchCandidates();
    },
    'candidate.candidates': {
      handler(newValue) {
        this.updateSelectedCandidatesAfterChange();

        // If we're on step 2 and this is the first time candidates are loaded,
        // select them all
        if (
          this.currentStep === 2
          && newValue
          && newValue.length > 0
          && this.selectedCandidates.length === 0
        ) {
          this.$nextTick(() => {
            this.selectAllCandidates();
          });
        }

        // Update validation state of selected candidates
        if (this.selectedCandidates.length > 0) {
          this.selectedCandidates.forEach((selected, index) => {
            const matchingCandidate = newValue.find(
              (c) => c._tempId === selected._tempId,
            );
            if (matchingCandidate) {
              this.selectedCandidates[index].isValid = this.validateFields({
                name: matchingCandidate.name,
                surname: matchingCandidate.surname,
                email: matchingCandidate.email,
              });
            }
          });
        }

        this.$nextTick(() => {
          this.restoreValidationStates();
        });
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/style/starter.scss";

.interview-input-header {
  display: flex;
  align-items: center;
  padding: 4px 0 4px 8px;
  gap: 4px;
  border-radius: 4px;
  background: #eee;
  width: fit-content;

  .input-columns {
    display: flex;
    align-items: center;
    gap: var(--Padding-Medium, 12px);
  }

  span {
    color: var(--Text-Colors-Secondary-Gray-Text, #878787);
    font-feature-settings: "liga" off, "clig" off;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    width: 197px;

    @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
      width: 76px;
    }
  }

  .checkbox-column {
    width: 20px;
  }
}

.candidate-checkbox {
  display: flex;
  align-items: center;
  width: 16px;
  margin-right: 0px;
  margin-left: 8px;
}

.select-all-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
}

.selected-summary {
  display: flex;
  align-items: center;
  gap: 2px;

  span {
    color: var(--Text-Colors-Secondary-Gray-Text, #878787);
    font-feature-settings: "liga" off, "clig" off;
    /* Typography/Body/3 - Regular */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
  }

  i {
    color: var(--Text-Colors-Secondary-Gray-Text, #878787);
    font-size: 16px;
  }
}

.interview-input-group {
  display: flex;
  align-items: center;
}

.ats-modal__sticky-header {
  padding-top: 16px;
  padding-bottom: 4px;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 2;
}

.candidates-list {
  padding-top: 8px;
}

.schedule-area {
  width: 100%;
  display: flex;
  margin-top: 32px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  border-radius: 4px;
  border: 1px solid var(--Stroke-Colors-Primary-Gray-Stroke, #e5e5e5);
  background: var(--Background-Colors-Bright-Gray, #fafafa);

  &__divider {
    width: 100%;
    height: 1px;
    background: var(--Stroke-Colors-Primary-Gray-Stroke, #e5e5e5);
  }

  &__header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--Padding-Small, 4px);
    align-self: stretch;

    h4 {
      color: var(--Text-Colors-Primary-Gray-Text, #333);
      font-feature-settings: "liga" off, "clig" off;
      /* Typography/Subtitle/3 - Medium */
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
    }

    span {
      color: var(--Text-Colors-Secondary-Gray-Text, #878787);
      font-feature-settings: "liga" off, "clig" off;
      /* Typography/Body/3 - Regular */
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
  }

  &__preview {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
    width: 100%;

    p {
      color: var(--Text-Colors-Primary-Gray-Text, #333);
      font-feature-settings: "liga" off, "clig" off;
      /* Typography/Subtitle/3 - Medium */
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
    }

    button {
      width: 100%;
      display: flex;
      padding: var(--Padding-Regular, 8px);
      align-items: center;
      justify-content: space-between;
      gap: var(--Padding-Small, 4px);
      border-radius: 4px;
      border: 1px solid var(--Stroke-Colors-Tertiary-Gray-Stroke, #e5e5e5);
      background: var(--Background-Colors-White, #fff);

      color: var(--Text-Colors-Primary-Gray-Text, #333);
      font-feature-settings: "liga" off, "clig" off;
      text-overflow: ellipsis;
      /* Typography/Body/3 - Regular */
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;

      @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
        height: auto;
      }

      span {
        color: var(--Text-Colors-Primary-Gray-Text, #ff8d06);
        font-feature-settings: "liga" off, "clig" off;
        text-overflow: ellipsis;
        /* Typography/Body/3 - Regular */
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
      }
    }
  }

  ::v-deep .custom-control-label {
    color: #333 !important;
    font-feature-settings: "liga" off, "clig" off;
    /* Typography/Body/3 - Regular */
    font-family: Roboto;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 400 !important;
    line-height: 20px !important;
    padding-top: 2px !important;
  }
}
::v-deep {
  .unified-connections {
    padding: 0 !important;
  }
  .form-group label {
    color: var(--Text-Colors-Primary-Gray-Text, #333);
    font-feature-settings: "liga" off, "clig" off;
    /* Typography/Subtitle/3 - Medium */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 4px;
  }

  .form-control {
    display: flex;
    padding: var(--Padding-Regular, 8px);
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid #e5e5e5 !important;
    background: #fff;
    box-shadow: none !important;
    color: #333;
    font-feature-settings: "liga" off, "clig" off;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;

    &:focus {
      outline: none;
      border-color: #ff8d06 !important;
      box-shadow: 0px 0px 0px 4px rgba(255, 141, 6, 0.3) !important;
    }
  }
  .form-control-feedback {
    display: none !important;
  }
  .untouched {
    &.has-danger .form-control {
      border-color: #e5e5e5 !important;
      color: #333 !important;
      box-shadow: none !important;
    }
  }

  .checkbox-candidate {
    .custom-control-label {
      cursor: pointer;
      &:hover {
        &::after {
          background: #FFE9CE;
        }
      }
      &::after {
        border: 1px solid #333;
        border-radius: 2px;
      }
      &::before {
        border-color: transparent !important;
        outline: none;
        box-shadow: none;
        width: 16px !important;
        height: 16px !important;
      }
    }
    .custom-control-input {
      cursor: pointer;
      &:focus {
        border-color: transparent !important;
      }
      &:checked {
        & ~ .custom-control-label {
          &::before {
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.86337 10.5836L3.55004 8.27026C3.29004 8.01026 2.87004 8.01026 2.61004 8.27026C2.35004 8.53026 2.35004 8.95026 2.61004 9.21026L5.39671 11.9969C5.65671 12.2569 6.07671 12.2569 6.33671 11.9969L13.39 4.94359C13.65 4.68359 13.65 4.26359 13.39 4.00359C13.13 3.74359 12.71 3.74359 12.45 4.00359L5.86337 10.5836Z" fill="white"/></svg>') !important;
            color: $white !important;
            background: $purple !important;
            font-size: 14px;
            text-align: center;
            position: absolute;
            left: -25px;
            border-radius: 2px;
          }
          &::after {
            display: none !important;
          }
        }
      }
    }
  }

  .error-info-area {
    display: flex;
    padding: 8px;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid var(--Stroke-Colors-Light-Red-Stroke, #f2b5b5);
    background: var(--Background-Colors-Light-Red, #f8dada);

    span {
      color: var(--Text-Colors-Red-Text, #631212);
      font-feature-settings: "liga" off, "clig" off;
      /* Typography/Small Text/1 - Regular */
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      flex: 1;
    }

    i {
      font-size: 20px;
    }
  }

  .success-info-area {
    display: flex;
    padding: 8px;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid var(--Stroke-Colors-Light-Red-Stroke, #b6eac9);
    background: var(--Background-Colors-Light-Red, #dbf4e4);
    margin-top: 16px;

    span {
      color: var(--Text-Colors-Red-Text, #19552e);
      font-feature-settings: "liga" off, "clig" off;
      /* Typography/Small Text/1 - Regular */
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      flex: 1;
    }
  }
}
.error-message {
  color: #de4747 !important;
  font-family: Roboto;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 18px !important;
  text-align: left !important;
  margin: 0 !important;
}
.info-message {
  color: #878787 !important;
  font-family: Roboto;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 18px !important;
  text-align: left !important;
  margin: 0 !important;
}

.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 8px;
  color: #858585;

  i {
    font-size: 18px;
  }
}

.end-list-indicator {
  text-align: center;
  padding: 16px;
  color: #858585;
  font-size: 14px;
}

.delete-icon {
  display: flex;
  width: 24px;
  height: 24px;
  padding: 2px;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  border: 1px solid #d4d4d4;
  background: transparent;
  transition: all 0.3s ease;

  &:hover {
    background: #eee;
  }
}
.delete-icon-empty {
  display: flex;
  width: 24px;
  height: 24px;
  padding: 2px;
  justify-content: center;
  align-items: center;
}
.search-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    flex-direction: column;
  }
}

.search-info {
  color: #878787;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.search-input-wrapper {
  position: relative;
  width: 250px;
}

.search-input {
  width: 100%;
  padding: 8px 36px 8px 12px;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  font-family: Roboto;
  font-size: 14px;
  line-height: 20px;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #ff8d06;
    box-shadow: 0px 0px 0px 4px rgba(255, 141, 6, 0.3) !important;
  }

  &::placeholder {
    color: #878787;
  }
}

.search-icon {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.no-results-message {
  text-align: center;
  padding: 24px 16px;
  color: #878787;
  font-family: Roboto;
  font-size: 14px;
  font-style: italic;
}

.unified-connections {
  padding: 1.5rem;

  &__select-label {
    color: var(--Text-Colors-Primary-Gray-Text, #333);
    font-feature-settings: 'liga' off, 'clig' off;
    /* Typography/Subtitle/3 - Medium */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 4px;
  }

  &__select-afterlist {
    position: sticky;
    bottom: 0;
    display: flex;
    height: 48px;
    padding: 14px 8px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: var(--Radius-XSmall, 2px);
    background: var(--Background-Colors-White, #FFF);
    border-top: 1px solid #E5E5E5;
  }

  &__select {
    ::v-deep #listbox-null {
      li:first-child {
        display: block !important;
      }
    }
  }

  &__select-area {
    display: flex;
    justify-content: space-between;

    @media only screen and (max-width: map-get($grid-breakpoints, 'md')) {
      flex-direction: column;
    }
  }

  &__select-item {
    width: 100%;

    &:first-child {
      margin-right: 8px;
    }

    @media only screen and (max-width: map-get($grid-breakpoints, 'md')) {
      width: 100%;
      margin-right: 0 !important;
      margin-top: 16px;
    }
  }
}

.add-btn {
  color: var(--Text-Colors-Primary-Orange-Text, #FF8D06);
  font-feature-settings: 'liga' off, 'clig' off;
  /* Typography/Body/3 - Regular */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  padding: 6px 0;

  i {
    margin-top: 0 !important;
  }

  &:hover {
    opacity: 0.8;
  }
}

::v-deep .multiselect {
  &__option--disabled {
    display: block !important;
    color: #C3C3C3 !important;
    pointer-events: auto !important;
    cursor: not-allowed !important;
  }

  &--active {
    .multiselect__tags {
      box-shadow: 0px 0px 0px 4px rgba(255, 141, 6, 0.30) !important;
      outline: 1px solid #FF8D06 !important;
      border-radius: 4px;
    }
  }

  &__content-wrapper {
    top: 48px;
    border-radius: 4px !important;
    border: 1px solid #E5E5E5 !important;
    background: #FFF;
    box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.12) !important;
  }

  &__tags {
    border-radius: 4px !important;
    box-shadow: 0 2px 6px 0 rgba(255, 255, 255, 0), inset 0 0 0 1px #c3c3c3 !important;
    padding-left: 8px !important;
  }

  &__option--highlight {
    background: #EEE !important;
  }

  &__select:before {
    content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.25537 9.51191L9.4137 11.6702C9.7387 11.9952 10.2637 11.9952 10.5887 11.6702L12.747 9.51191C13.272 8.98691 12.897 8.08691 12.1554 8.08691H7.8387C7.09703 8.08691 6.73037 8.98691 7.25537 9.51191Z" fill="%23333333"/></svg>');
    border: 0;
    top: 20%;
  }

  &__option--selected:after {
    content: "";
    display: none;
  }

  &--disabled {
    pointer-events: auto !important;
  }
}
</style>
